// Write your code here
import Slider from 'react-slick'

import './index.css'

import PlanetItem from '../PlanetItem'

const PlanetsSlider = props => {
  const {planetsList} = props
  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
  }
  return (
    <div className="main-container">
      <h1 className="main-heading">PLANETS</h1>
      <div className="slider-container" data-testid="planets">
        <Slider {...settings}>
          {planetsList.map(eachItem => (
            <PlanetItem key={eachItem.id} planetsDetails={eachItem} />
          ))}
        </Slider>
      </div>
    </div>
  )
}

export default PlanetsSlider
